import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import AppPicker from "@/components/AppPicker.vue"
  import AppDeck from "@/components/AppDeck.vue"
  import AppStats from "@/components/AppStats.vue"
  import options from "@/data/options"
  import { nextTick, reactive } from "vue"
  import { Card, State, Controls } from "@/types/index"

  // use random card generator
  import generator from "@/data/generator"

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const totalRounds = options.draftSize
  const allCards = generator.generateBatch(options.batchSize)

  let state: State = reactive({
    currentDeal: [],
    currentRound: 0,
    currentDeck: [],
  })

  let controls: Controls = reactive({
    hoveredStatName: null,
    hoveredStatValue: null,
  })

  function start() {
    if (state.currentRound === 0) {
      state.currentDeal = getRandomDeal()
      state.currentRound += 1
    }
  }

  async function restart() {
    if (state.currentRound != 0) {
      state.currentDeal.length = 0
      state.currentDeck.length = 0
      state.currentRound = 0
      // gives time for dom transitions to happen
      await nextTick()
      start()
    }
  }

  function getRandomDeal(dealSize = options.dealSize): Card[] {
    let cards: Card[] = []
    for (let i = 0; i < dealSize; i++) {
      let randomIndex = Math.floor(Math.random() * allCards.length)
      // ensures that 3 different cards are dealt
      while (cards.find((el) => el.id === allCards[randomIndex].id)) {
        randomIndex = Math.floor(Math.random() * allCards.length)
      }
      // if the card has already been drafted give it new unique id...
      let card = allCards[randomIndex]
      if (state.currentDeck.includes(card)) {
        // ...which also requires making new object
        card = { ...card }
        card.id = generator.generateId()
      }
      cards.push(card)
    }
    return cards
  }

  function pickCard(picked: Card) {
    // find the last card of a picked type
    let lastTypeIndex = state.currentDeck.length
    if (lastTypeIndex !== 0) {
      for (let i = state.currentDeck.length - 1; i >= 0; i--) {
        if (state.currentDeck[i].type === picked.type) {
          lastTypeIndex = i
          break
        }
      }
    }
    // place picked behind the last card of a type
    state.currentDeck.splice(lastTypeIndex + 1, 0, picked)
    // update rounds
    if (state.currentRound <= totalRounds) {
      state.currentRound += 1
      state.currentDeal = getRandomDeal()
    } else {
      state.currentRound += 1
      state.currentDeal.length = 0
    }
  }

  function hoverHandler(payload: { statName: string; statValue: number }) {
    controls.hoveredStatName = payload.statName
    controls.hoveredStatValue = payload.statValue
  }

  function unhoverHandler() {
    controls.hoveredStatName = null
    controls.hoveredStatValue = null
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppPicker, {
      deal: _unref(state).currentDeal,
      round: _unref(state).currentRound,
      "total-rounds": _unref(totalRounds),
      onPick: _cache[0] || (_cache[0] = ($event: any) => (pickCard($event))),
      onRestart: _cache[1] || (_cache[1] = ($event: any) => (restart())),
      onStart: _cache[2] || (_cache[2] = ($event: any) => (start()))
    }, null, 8, ["deal", "round", "total-rounds"]),
    _createVNode(AppDeck, {
      deck: _unref(state).currentDeck,
      "hovered-stat-name": _unref(controls).hoveredStatName,
      "hovered-stat-value": _unref(controls).hoveredStatValue
    }, null, 8, ["deck", "hovered-stat-name", "hovered-stat-value"]),
    _createVNode(AppStats, {
      deck: _unref(state).currentDeck,
      onHoverStat: _cache[3] || (_cache[3] = ($event: any) => (hoverHandler($event))),
      onUnhover: _cache[4] || (_cache[4] = ($event: any) => (unhoverHandler()))
    }, null, 8, ["deck"])
  ]))
}
}

})